(() => {
  for (const section of document.querySelectorAll('.pdp-v2')) {
    const form=section.querySelector('.product-form');
    const select=section.querySelector('[data-variant]');
    const variants=JSON.parse(section.querySelector('[data-variants]').textContent);
    const picker=section.querySelector('[data-option-picker]');
    const quantity=form.elements.quantity;
    section.classList.add('pdp-ready');
    const renderAvailability=()=>{
      const fields=[...section.querySelectorAll('[data-option-position]')];
      const choices=fields.map(f=>f.querySelector('input:checked')?.value);
      fields.forEach((field,index)=>{
        field.querySelector('[data-option-label]').textContent=choices[index]||'';
        field.querySelectorAll('input').forEach(input=>{
          const possible=variants.some(v=>v.available&&v.options.every((option,i)=>i===index?option===input.value:i<index?option===choices[i]:true));
          input.closest('.option-pill').classList.toggle('option-unavailable',!possible);
        });
      });
    };
    function updatePurchase(variant){
      const add=section.querySelector('[data-add]');
      const sale=section.querySelector('[data-sale]');
      if(!variant){add.disabled=true;add.textContent=section.dataset.unavailableLabel;select.disabled=true;sale.hidden=true;return;}
      select.disabled=false;
      const rule=variant.quantityRule||{min:1,increment:1};
      quantity.min=rule.min||1;quantity.step=rule.increment||1;
      if(rule.max)quantity.max=rule.max;else quantity.removeAttribute('max');
      const current=Number(quantity.value)||Number(quantity.min);
      quantity.value=Math.max(Number(quantity.min),current);
      if(rule.max)quantity.value=Math.min(rule.max,Number(quantity.value));
      const remainder=(Number(quantity.value)-Number(quantity.min))%Number(quantity.step);
      if(remainder)quantity.value=Number(quantity.value)-remainder;
      const saved=variant.rawCompare>variant.rawPrice?Math.round((variant.rawCompare-variant.rawPrice)*100/variant.rawCompare):0;
      sale.hidden=!saved;sale.textContent=section.dataset.savePercent.replace('__amount__',saved);
    }
    picker?.addEventListener('change',()=>{
      const choices=[...picker.querySelectorAll('[data-option-position]')].map(field=>field.querySelector('input:checked')?.value);
      const variant=variants.find(v=>v.options.every((value,i)=>value===choices[i]));
      renderAvailability();updatePurchase(variant);
      if(variant){select.value=String(variant.id);select.dispatchEvent(new Event('change',{bubbles:true}));}
    });
    select.addEventListener('change',()=>updatePurchase(variants.find(v=>String(v.id)===select.value)));
    renderAvailability();updatePurchase(variants.find(v=>String(v.id)===select.value));
    section.querySelectorAll('[data-quantity-delta]').forEach(button=>button.addEventListener('click',()=>{
      if(Number(button.dataset.quantityDelta)<0)quantity.stepDown();else quantity.stepUp();quantity.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    const thumbnails=[...section.querySelectorAll('[data-show-media]')];
    const markThumb=id=>thumbnails.forEach(button=>button.setAttribute('aria-current',String(button.dataset.showMedia===String(id))));
    thumbnails.forEach(button=>button.addEventListener('click',()=>markThumb(button.dataset.showMedia)));
    select.addEventListener('change',()=>{const variant=variants.find(v=>String(v.id)===select.value);if(variant?.media)markThumb(variant.media);});
    const visible=section.querySelector('[data-media]:not([hidden])');if(visible)markThumb(visible.dataset.media);
  }
})();
